export default {
	TABLE_TITLE: 'Waiting time grid entries',
	WAITING_TIME_GRID_ENTRY_ADDED: 'Waiting time grid entry added',
	WAITING_TIME_GRID_ENTRY_EDITED: 'Waiting time grid entry edited',
	WAITING_TIME_GRID_ENTRY_DELETED: 'Waiting time grid entry deleted',
};
